<div class="scrollable-parent">
    <ev-grid-table [gridModel]="displayTemplate" class="scrollable-table">
        <ev-th>
            @for(column of headers; track $index) { @if(column?.isSortable) {
            <ev-td
                [area]="column.prop"
                (click)="updateSort(column.prop)"
                [isSelectable]="true"
                [textAlignment]="column.textAlignment ?? 'left'"
                [selected]="sortConfig().sortOption.prop == column.prop"
            >
                {{ column.name.toUpperCase() }}
            </ev-td>
            } @else {
            <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                {{ column.name.toUpperCase() }}
            </ev-td>
            } }
        </ev-th>

        @if (tableData()) { @for(rowData of tableData(); track $index) {
        <ev-tr class="ev-row" [hasRowContent]="true" (isExpanded)="isRowExpanded($event, rowData)" [class.expanded]="rowData.expanded">
            <ev-td area="info" header="" column title="">
                <div class="info">
                    @if ((rowData.valueHistoryTypeEnum === valueHistoryType.ETakst || rowData.valueHistoryTypeEnum === valueHistoryType.Takst) && rowData.refId
                    && hasSearchAppraisalRole()) {
                        <div class="icon" cdkOverlayOrigin #icon="cdkOverlayOrigin" [class.warning]="rowData.isLatestAndAppraisal" [class.open]="rowData.tooltipVisible" (click)="rowData.tooltipVisible = !rowData.tooltipVisible"></div>
                        @if (rowData.appraisalApprovalStatusEnum === appraisalApprovalStatus.Processing) {
                            <ev-cdk-tooltip [title]="'Ubehandlet etakst'" [origin]="icon" [visible]="rowData.tooltipVisible" [width]="'340'" (close)="rowData.tooltipVisible = false">
                                <span class="tooltip-content">Etaksten bør godkjennes eller avvises. Åpne hendelsen for mer info.</span>
                            </ev-cdk-tooltip>
                        } @else if (rowData.appraisalApprovalStatusEnum === appraisalApprovalStatus.Rejected) {
                            <ev-cdk-tooltip [title]="'Etakst er avvist'" [origin]="icon" [visible]="rowData.tooltipVisible" [width]="'340'" (close)="rowData.tooltipVisible = false">
                                <span class="tooltip-content">Etakst er avvist. Åpne hendelsen for mer info.</span>
                            </ev-cdk-tooltip>
                        }
                    }
                </div> 
            </ev-td>
            <ev-td area="date" header="Dato" column title="Dato" [fontBold]="sortConfig().sortOption.prop == 'date'">
                <div class="date-column" [ngClass]="{ 'clickable': isOpenableAppraisal(rowData) }" (click)="getAppraisalsUrl(rowData)">
                    <span class="column-data identifier identifier--start">{{ rowData.date | date : "shortDate" | defaultconvert : "-"}}</span>
                    <span class="column-data identifier identifier--end">{{ rowData.dateDescription }}</span>
                    <span class="arrow-right"></span>
                </div>
            </ev-td>
            <ev-td
                area="priceAssumptionValue"
                header="Prisantydning"
                column
                title="Prisantydning"
                textAlignment="right"
                [fontBold]="sortConfig().sortOption.prop == 'priceAssumptionValue'"
            >
                <div class="column-data">{{ rowData.priceAssumption | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td area="value" header="Pris" column title="Pris" textAlignment="right" [fontBold]="sortConfig().sortOption.prop == 'value'">
                <div class="column-data">{{ rowData.value | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td area="commonDebt" header="F gjeld" column title="F gjeld" textAlignment="right" [fontBold]="sortConfig().sortOption.prop == 'commonDebt'">
                <div class="column-data">{{ rowData.commonDebt | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td
                area="totalValue"
                header="Pris ink fg"
                column
                title="Pris ink fg"
                textAlignment="right"
                [fontBold]="sortConfig().sortOption.prop == 'totalValue'"
            >
                <div class="column-data">{{ rowData.totalValue | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td
                area="squareMeterPrice"
                header="m² pris"
                column
                title="m2pris"
                textAlignment="right"
                [fontBold]="sortConfig().sortOption.prop == 'squareMeterPrice'"
            >
                <div class="column-data">{{ rowData.squareMeterPrice | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td area="status" header="" column title="">
                <div class="status-wrapper">
                    
                    @if( (rowData.valueHistoryTypeEnum === valueHistoryType.ETakst || rowData.valueHistoryTypeEnum === valueHistoryType.Takst) && rowData.refId
                    && hasSearchAppraisalRole()) {
                    <div class="etakst-panel">
                        @if(rowData.appraisalApprovalStatusEnum === appraisalApprovalStatus.Processing) {
                        <div class="action-button" (click)="showAppraisalDialog(rowData.refId, rowData.reportId, rowData.valueHistoryTypeEnum)">Behandle</div>
                        } @else {
                        <div class="action-button" (click)="showAppraisalDialog(rowData.refId, rowData.reportId, rowData.valueHistoryTypeEnum)">Endre</div>
                        }
                    </div>}
                    @else {
                        <div class="column-data">{{ rowData.whiteLabel }}</div>
                    }
                </div>
            </ev-td>
            <ev-td area="links" header="" column title="" textAlignment="right">
                <div class="adLinks" [ngClass]="{ 'showDropdownArrow': rowData.adUrls.length > 1 || rowData.adUrls.length === 1 && rowData.hasAdText }">
                    @if(rowData.hasAdText === true) {
                    <div class="links-content">
                        <div class="link-with-icon" (click)="openProspectReport(rowData.detailId)">
                            <div class="main-link-item prospect"></div>
                            <span>Se annonsetekst</span>
                        </div>
                    </div>
                    } @else if (rowData.hasFinnAd === true) {
                        <div class="links-content">
                            <a [href]="rowData.finnUrl" target="_blank" class="link-with-icon">
                                <span class="main-link-item" [ngClass]="rowData.valueHistoryTypeEnum === valueHistoryType.Meglersalg ? 'finn' : 'takst'"></span>
                                Se Finn-annonse
                            </a>
                        </div>
                    } @else if (rowData.hasHjemAd === true) {
                        <div class="links-content">
                            <a [href]="rowData.hjemUrl" class="link-with-icon" target="_blank"><span class="main-link-item hjem"></span> Se Hjem-annonse </a>
                        </div>
                    }
                    @if (rowData.adUrls.length > 1 || rowData.adUrls.length === 1 && rowData.hasAdText) {
                        <div class="adDropdownArrow" [dropdownTriggerFor]="adDropdown"></div>
                        <ev-dropdown-base #adDropdown>
                            <div class="dropdown-content">
                                @if(rowData.hasAdText === true) {
                                    <div class="dropdown-item" (click)="openProspectReport(rowData.detailId)">
                                        Se annonsetekst
                                    </div>
                                } @if (rowData.hasFinnAd === true) {
                                    <a [href]="rowData.finnUrl" target="_blank" class="dropdown-item">
                                        Se Finn-annonse
                                    </a>
                                } @if (rowData.hasHjemAd === true) {
                                    <a [href]="rowData.hjemUrl" target="_blank" class="dropdown-item">
                                        Se Hjem-annonse
                                    </a>
                                }
                            </div>
                        </ev-dropdown-base>
                    }
                </div>

                @if(hasAppraisalRole() && rowData.valueHistoryTypeEnum === valueHistoryType.ETakstMegler && rowData.appraisalStatusEnum !==
                appraisalStatus.Created) {
                <div class="links-content etakst-panel">
                    <div class="link-with-icon" (click)="getAppraisalReport(rowData)">
                        <span class="main-link-item etakst"></span>
                        <span>Se etakst</span>
                    </div>
                </div>
                } @if(hasSearchAppraisalRole() && (rowData.valueHistoryTypeEnum === valueHistoryType.ETakst || rowData.valueHistoryTypeEnum ===
                valueHistoryType.Takst) && rowData.refId) {
                <div class="links-content etakst-panel">
                    <div class="link-with-icon" (click)="getAppraisalValueReport(rowData)">
                        <div class="main-link-item takst"></div>
                        <span>Se valideringsrapport</span>
                    </div>
                </div>
                } @if (hasEvEstimateRole() && rowData.valueHistoryTypeEnum === valueHistoryType.LagretEstimat && rowData.detailId) {
                <div class="links-content etakst-panel">
                    <!-- <a class="link-with-icon" [attr.href]="this.evWebUrl() + '/Report/GetStoredEstimate?id=' + rowData.detailId" target="_blank"> -->
                    <a class="link-with-icon" [href]="rowData.estimateUrl" target="_blank">
                        <span class="main-link-item takst"></span>
                        <span>Se evEstimat</span>
                    </a>
                    <!-- </a> -->
                </div>
                }
            </ev-td>
            <div row-content>
                @if(isLoadingDetails()[rowData.index]) {
                <div class="mini-loading-wrapper">
                    <ev-logo-loader variant="dots" width="40px" />
                </div>
                } @else if(customerUnitDetails()[rowData.index]){ @if (rowData.valueHistoryTypeEnum === valueHistoryType.Meglersalg) {
                    <div>Here be details for megler salg</div>
                } @else if (rowData.valueHistoryTypeEnum === valueHistoryType.ETakstMegler || rowData.valueHistoryTypeEnum === valueHistoryType.ETakst) {
                    <appraisal
                        [detailAppraisal]="rowData.appraisalDetails()"
                        [reportId]="rowData.reportId"
                        [isLatest]="rowData.isLatestAndAppraisal"
                        [detailSaleInfo]="rowData.infoText"
                        [appraisalStatus]="rowData.appraisalApprovalStatusEnum"
                        [appraisalDeniedReasons]="appraisalDeniedReasons()"
                    ></appraisal>
                }@else if( rowData.valueHistoryTypeEnum === valueHistoryType.Takst){
                    <div>Here be details for takst</div>
                } @else if (rowData.valueHistoryTypeEnum === valueHistoryType.LagretEstimat) {
                    <saved-estimate-details [data]="customerUnitDetails()[rowData.index]"></saved-estimate-details>
                } }
            </div>
        </ev-tr>
        } }
    </ev-grid-table>
    <appraisal-verification
        [visible]="showAppraisalValuationDialog"
        [appraisalValues]="appraisalValues"
        [appraisalDeniedReasons]="appraisalDeniedReasons()"
        (confirm)="closeAppraisalDialog()"
        (close)="closeAppraisalDialog()"
    ></appraisal-verification>
</div>
@if(originalData().length > rowsToShow) {
<div class="show-more-button">
    <button (click)="onShowMore()">Vis flere</button>
</div>
}
